import { render, staticRenderFns } from "./BiaodiIntroduce.vue?vue&type=template&id=02b85619&"
import script from "./BiaodiIntroduce.vue?vue&type=script&lang=js&"
export * from "./BiaodiIntroduce.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports